<template>
  <span>{{ formattedBudgetType }}</span>
</template>

<script>
export default {
  name: 'BudgetTypeCell',
  props: {
    row: {
      type: Object,
      required: true
    },
    budgetListInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedBudgetType() {
      return this.budgetListInfo[this.row.budget_type] || '--'
    }
  }
}
</script>